module.exports = __webpack_public_path__ + "img/spring.4830e7b3.svg";